export const environment = {
    production: false,
    version: '22.0.2 - 2026-10-29 13:21:39 (local)',
    environment: 'Development',
    msalConfig: {
        auth: {
            clientId: '69fd3cd5-1547-40c0-a3f9-77b09b8bdc7b',
            authority: 'https://login.microsoftonline.com/common'
        },
        scopes: ['user.read'],
        graphUri: 'https://graph.microsoft.com/v1.0/me'

    },
    adminConfig: { 
        apiUri: 'https://config-api.development.crono.dk',
        applicationInsightsId: 'c1c84ed1-b5d0-4197-b722-1b93eb99487a',
        applicationInsightsApiKey: 'yudccixj55g5a08u3g4k1j4k05nxdjebi7eos1cc',
        applicationInsightsUri: 'https://api.applicationinsights.io/v1/apps',
        syncApiUrl: 'https://sync.development.crono.dk'
    }
};
